import { api } from './api';

const getInstructionsList = async ({ data, pageNumber, pageSize }) => {
  const response = await api({
    url: `AutoLoadings/getPagedList`,
    method: 'GET',
    params: {
      Page: pageNumber || 1,
      PageSize: pageSize || 350,
      ...data,
    },
  });

  return response.data;
};

const getInstructionsTemp = async () => {
  const response = await api({
    url: `AutoLoadingTemps/getAutoLoadingTemp`,
    method: 'GET',
  });

  return response.data;
};

const updateAutoLoadingCommand = async (data) => {
  const response = await api({
    url: `AutoLoadings/Update`,
    method: 'PUT',
    data,
  });

  return response.data;
};

const prepareAutoLoading = async (data) => {
  const response = await api({
    url: `AutoLoadings/PrepareAutoLoading`,
    method: 'POST',
    data,
  });

  return response.data;
};

const instructionsDetailList = async ({
  data,
  pageNumber = 1,
  pageSize = 350,
  showOnlyPriced = false,
}) => {
  const response = await api({
    url: `AutoLoadingDetailTemps/getAutoLoadingDetailList`,
    method: 'POST',
    data: {
      Page: data?.page || pageNumber,
      PageSize: data?.pageSize || pageSize,
      customerId: data?.customerId,
      autoLoadingId: data?.autoLoadingId,
      integrationId: data?.integrationId,
      cardNumber: data?.cardNumber ? `${data?.cardNumber}` : null,
      deliveryCode: data?.deliveryCode,
      name: data?.name,
      refNo: data?.refNo,
      showOnlyPriced: data?.showOnlyPriced || showOnlyPriced,
      surname: data?.surname,
      addressIdList: data?.addressIdList,
      OrderType : data?.OrderType,
      OrderByValue :data?.OrderByValue
    },
  });

  return response.data;
};

const autoLoadingDetailList = async (data) => {
  return instructionsDetailList({ data });
};

const instructionsTempList = async ({
  data,
  pageNumber = 1,
  pageSize,
  showOnlyPriced = false,
  autoLoadingId,
  integrationId,
}) => {
  const response = await api({
    url: `AutoLoadingDetailTemps/getPagedList`,
    method: 'GET',
    params: {
      Page: data?.page || pageNumber,
      PageSize: data?.pageSize || pageSize,
      showOnlyPriced,
      autoLoadingId,
      integrationId,
    },
  });

  return response.data;
};

const getById = async (data) => {
  const response = await api({
    url: `AutoLoadings/getPagedList`,
    method: 'GET',
    params: data,
  });

  return response.data;
};


const getTotalAutoLoadingParams = async ({ autoLoadingId = 0, integrationId = 0 }) => {
  const response = await api({
    url: `AutoLoadingDetailTemps/getTotalAutoLoading`,
    method: 'GET',
    params: {
      autoLoadingId,
      integrationId,
    },
  });

  return response.data;
};

const getReport = async ({ customerId, vouId, id }) => {
  const response = await api({
    url: `Report/autoLoadingReport`,
    method: 'GET',
    params: {
      customerId,
      vouId,
      id,
    },
  });

  return response.data;
};

const instructionDelete = async (data) => {
  const response = await api({
    url: `AutoLoadings/delete`,
    method: 'DELETE',
    params:{
      customerId: window.customerId
    },
    data: {
      ...data,
      customerId: window.customerId
    },
  });

  return response.data;
};

const instructionDeleteTemp = async (data) => {
  const response = await api({
    url: `AutoLoadings/DeleteTemp`,
    method: 'DELETE',
    data,
  });

  return response.data;
};

const instructionUpdate = async (data) => {
  const response = await api({
    url: `AutoLoadings/update`,
    method: 'PUT',
    data,
  });

  return response.data;
};

const instructionAdd = async (data) => {
  const response = await api({
    url: `AutoLoadings/createAutoLoadingApproveCommand`,
    method: 'POST',
    data,
  });

  return response.data;
};

const instructionDetailAdd = async (data) => {
  const response = await api({
    url: `AutoLoadingDetails/add`,
    method: 'POST',
    data,
  });

  return response.data;
};

const instructionExcelDownload = async (data) => {
  const response = await api({
    url: `AutoLoadingDetailTemps/autoLoadingDetailTempExcelTemplate`,
    method: 'POST',
    data,
    responseType: 'blob',
  });

  return response.data;
};

const instructionExcelUpload = async (data) => {
  const response = await api({
    url: `AutoLoadingDetailTemps/autoLoadingDetailTempExcelUpload`,
    method: 'POST',
    data,
  });

  return response.data;
};

const instructionDetailPriceUpdate = async (data) => {
  const response = await api({
    url: `AutoLoadingDetailTemps/updateAutoLoadingDetailTempPrice`,
    method: 'POST',
    data,
  });

  return response.data;
};

const instructionDetailExcelTemplate = async (data) => {
  const response = await api({
    url: `AutoLoadingDetails/AutoLoadingDetailExcelTemplate`,
    method: 'POST',
    data,
    responseType: 'blob',
  });

  return response.data;
};

const instructionDetailExcelUpload = async (data) => {
  const response = await api({
    url: `AutoLoadingDetails/AutoLoadingDetailExcelUpload`,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  });

  return response.data;
};

const instructionDetailCopy = async (data) => {
  const response = await api({
    url: `AutoLoadingTemps/copyAutoLoadingTemp`,
    method: 'POST',
    data,
  });

  return response.data;
};

const getAutoLoadingApprovalList = async ({ data }) => {
  const response = await api({
    url: `AutoLoadings/getPagedList?Page=${data?.pageNumber}&PageSize=${data?.pageSize}&customerId=${data?.customerId}&vouId=${data?.vouId}&IsPendingApproval=${true}&isActive=${true}`,
    method: 'GET',
  });

  return response.data;
};

const autoUploadInstructionsServices = {
  prepareAutoLoading,
  getInstructionsList,
  getInstructionsTemp,
  instructionDelete,
  instructionDeleteTemp,
  instructionUpdate,
  instructionAdd,
  instructionDetailAdd,
  instructionExcelDownload,
  instructionExcelUpload,
  instructionDetailPriceUpdate,
  instructionsDetailList,
  instructionDetailExcelTemplate,
  instructionDetailExcelUpload,
  instructionDetailCopy,
  getById,
  getTotalAutoLoadingParams,
  getReport,
  instructionsTempList,
  getAutoLoadingApprovalList,
  autoLoadingDetailList,
  updateAutoLoadingCommand,
};

export default autoUploadInstructionsServices;
